<template>
    <div class="wrapper">
        <div>
            <h2>选择收货地址</h2>
            <y-address></y-address>

        </div>
        <div>
            <h2>商品清单</h2>
            <y-product
                :cartProducts="cartProducts"
                :getCartProducts="getCartProducts"
            ></y-product>

        </div>
        <div>
            <h2>订单信息</h2>
            <y-order></y-order>
        </div>
        <div class="pay">
            <div><span>商品合计：</span><span>￥{{total.toFixed(2)}}</span></div>
            <div><span>实付款：</span><span>￥{{total.toFixed(2)}}</span></div>
            <el-tooltip v-show="cartProducts.length===0" effect="dark" content="请添加商品" placement="left">
                <el-button style="cursor: not-allowed" type="primary">支付</el-button>
            </el-tooltip>
            <el-button :loading="btnLoading" v-show="cartProducts.length!==0" @click.native="order">支付</el-button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Address from '../components/SupplyCh/Address';
    import Order from '../components/SupplyCh/Order';
    import Product from '../components/SupplyCh/Product';
    import {getCartProducts, order, host} from '../stores/api';
    import { createNamespacedHelpers } from 'vuex';

    Vue.component('y-address', Address);
    Vue.component('y-product', Product);
    Vue.component('y-order', Order);
    const {mapMutations, mapState} = createNamespacedHelpers('supplyChainStore');
    export default {
        data () {
            return {
                btnLoading: false,
                cartProducts: [],
            };
        },
        beforeMount() {
            this.getCartProducts();
        },
        methods: {
            async getCartProducts() {
                getCartProducts().then(res => {
                    this.cartProducts = res.data.goods_list.map(item => ({
                        ...item,
                        goods_attr_list: [],
                        getFlag: false,
                        modify: Number(item.goods_price_no)
                    }));
                });
            },
            async order() {
                // if (!this.orderForm.single_number) {
                //     this.$notify.error({
                //         title: '操作失败',
                //         message: '请填写vip号',
                //     });
                //     return;
                // }
                this.btnLoading = true;
                // console.log(this.orderForm)
                await order(this.orderForm).then((res) => {
                    const url = host + '/' + res.data.msg;
                    window.location.href = url;
//                    window.open(url);
                    this.getCartProducts();
                    this.setOrderForm({postscript: '', single_number: '', order_images: ''});
                    console.log(res)
                }).catch((err) => {
                    this.$notify.error({
                        title: '操作失败',
                        message: '请选择收货地址',
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            ...mapMutations(['setOrderForm']),
        },
        computed: {
            total() {
                let total = 0;
                this.cartProducts.forEach(item => {
                    const {goods_number, modify} = item;
                    total += Number(goods_number) * modify;
                });
                return total;
            },
            ...mapState(['orderForm']),
        },
        watch: {
            cartProducts(val) {
                let carts = {};
                let temp = '';
                val.forEach(item => {
                    const {rec_id, modify} = item;
//                    carts.push({[rec_id]: modify});
                    temp += rec_id + ',';
                    carts[rec_id] = modify;
                });
                this.setOrderForm({carts, rec_id: temp.substr(0, temp.length - 1)});
            },
        }
    };
</script>

<style lang="less" scoped>
    @import "../default";

    .wrapper {
        font-size: 16px;

        & > div {
            margin-bottom: 35px;
            & > h2 {
                margin-bottom: 24px;
                color: @font_gary;
                font-size: 20px;
            }
        }

        .pay {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            & > div {
                width: 250px;
                display: inline-flex;
                justify-content: space-between;

            }
            & > div:nth-child(1) {
                margin-bottom: 10px;
                & > span {
                    font-size: 14px;
                    color: #636975;
                }
            }
            & > div:nth-child(2) {
                width: 250px;
                margin-bottom: 20px;
                font-size: 20px;
                & > span:nth-child(1) {
                    color: @font_black;
                }
                & > span:nth-child(2) {
                    color: #f74845;
                }
            }
            & > button {
                width: 146px;
                height: 40px;
                padding: 0;
                background: #f74845;
                font-size: 18px;
                color: #ffffff;
                border: 0;
                border-radius: 4px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/router/SupplyChain.vue